// 弹窗展示控制字段
const dialogVisibleArray = {
  deleteVisible: false, // 启用弹窗
  addVisible: false, // 签约拒绝弹窗
};
const rules = {
  ruleName: [{ required: true, message: '请填写规则名称', trigger: 'blur' }],
  ruleType: [{ required: true, message: '请选择推送时间', trigger: 'blur' }],
  articleId: [{ required: true, message: '请选择推送内容', trigger: 'blur' }],
};
// 向外暴露，利于外部引用
export { dialogVisibleArray, rules };
